module.exports = __webpack_public_path__ + "img/logo-black.f48e2bb4.svg";